export const reparationTranslations = {
  // Barre urgence
  emergency_bar: '🚨 Infiltration active ? Appelez maintenant : 418-476-9950 (7j/7)',

  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'Réparation toiture Lévis',
  hero_h1: 'Réparation de toiture à Lévis — Urgence 7j/7',
  hero_subtitle: "Infiltration d'eau, bardeaux arrachés, glace au toit. On intervient sous 24h, soumission gratuite, garantie écrite.",
  hero_cta_call: '🚨 Appeler maintenant',
  hero_cta_inspection: 'Demander une inspection',
  hero_badge_1: 'Intervention 24h',
  hero_badge_2: 'Disponible 7j/7',
  hero_badge_3: 'Certifié',

  // Problèmes
  problemes_h2: 'Les réparations de toiture qu\u0026rsquo;on fait à Lévis',
  probleme_1_title: "Infiltration d'eau active",
  probleme_1_desc: 'Tache au plafond, eau qui coule, moisissure dans l\u0026rsquo;entretoit.',
  probleme_2_title: 'Bardeaux arrachés par le vent',
  probleme_2_desc: 'Bardeaux manquants, fissurés ou soulevés après une tempête.',
  probleme_3_title: 'Solins métal endommagés',
  probleme_3_desc: 'Solins décollés, rouillés ou improperly scellés autour des cheminées et évents.',
  probleme_4_title: 'Évent de toiture brisé',
  probleme_4_desc: 'Évent fissuré, rouillé ou détaché causant des infiltrations.',
  probleme_5_title: 'Glace au toit / barrage de glace',
  probleme_5_desc: 'Accumulation de glace qui force l\u0026rsquo;eau à rentrer sous le bardeau.',
  probleme_6_title: 'Trou ou fissure ponctuelle',
  probleme_6_desc: 'Dommage localisé par une branche, un objet ou l\u0026rsquo;usure.',

  // Process
  process_h2: 'Comment ça se passe quand vous nous appelez',
  process_step1_title: 'Appel ou demande en ligne',
  process_step1_desc: 'Réponse sous 1h ouvrable. On évalue l\u0026rsquo;urgence au téléphone.',
  process_step2_title: 'Inspection sur place',
  process_step2_desc: 'Sous 24–48h selon urgence. Photos, diagnostic, plan d\u0026rsquo;action.',
  process_step3_title: 'Soumission claire',
  process_step3_desc: 'Prix détaillé avec photos du problème. Pas de jargon, pas de surprise.',
  process_step4_title: 'Réparation effectuée',
  process_step4_desc: 'Souvent même journée si urgent. Propreté garantie, garantie écrite remise.',

  // Prix
  prix_h2: 'Combien coûte une réparation de toiture à Lévis ?',
  prix_intro: "Une réparation, c'est pas une réfection. Voici les vraies fourchettes.",
  prix_table_type: 'Type de réparation',
  prix_table_price: 'Prix indicatif',
  prix_row1_type: 'Petite réparation (quelques bardeaux)',
  prix_row1_price: '350 $ – 800 $',
  prix_row2_type: 'Réparation moyenne (section, solin)',
  prix_row2_price: '800 $ – 2 000 $',
  prix_row3_type: 'Infiltration majeure + dégât pontage',
  prix_row3_price: '2 000 $ – 6 000 $',
  prix_row4_type: 'Bâche d\u0026rsquo;urgence temporaire',
  prix_row4_price: '250 $ – 500 $',
  prix_note: "Inspection toujours gratuite. Soumission avant tout travail. Garantie écrite sur les réparations.",

  // Urgence
  urgence_h2: "Une infiltration n'attend pas",
  urgence_text: "Chaque heure qu'une infiltration coule, l'eau pénètre l'isolation, gonfle le gypse, fait moisir l'entretoit. Une réparation à 800 $ peut devenir un chantier à 8 000 $ en 2 semaines. Si vous voyez de l'eau, appelez aujourd'hui.",
  urgence_cta: '📞 Appeler maintenant 418-476-9950',

  // Témoignage
  temoin_text: "C'était un soir de mars, pluie de printemps qui tombait en rafales. Ma femme a remarqué une tache brune au plafond de la chambre d'amis. J'ai fait appel à un couvreur partenaire via Couvreur-Lévis.com à 19h, pensant tomber sur la boîte vocale. Ben non — quelqu'un a répondu, a pris mes infos, et a dit qu'un couvreur passerait le lendemain matin. Le gars est arrivé à 8h30, a trouvé un solin de cheminée décollé et trois bardeaux arrachés. Il a pris des photos, donné une soumission à 11h, et a commencé les travaux l'après-midi. Le soir, c'était scellé, propre, et on avait une garantie écrite de 3 ans sur la réparation. Aujourd'hui, zéro problème. Ces gars-là comprennent l'urgence.",
  temoin_name: 'Robert D.',
  temoin_location: 'Charny',
  temoin_project: "Infiltration majeure, mars 2025",

  // FAQ
  faq_h2: 'Questions fréquentes sur la réparation de toiture',
  faq_q1: 'Combien de temps avant que vous interveniez ?',
  faq_a1: "Pour les urgences actives (eau qui coule), on intervient sous 24h ouvrables. Pour les réparations non urgentes, l'inspection est généralement faite sous 48h. On vous donne un horaire précis dès l'appel.",
  faq_q2: 'Travaillez-vous en hiver pour les urgences ?',
  faq_a2: "Oui, absolument. On fait des réparations d'urgence 12 mois par année. En hiver, on utilise des matériaux conçus pour le froid et on pose des bâches temporaires si nécessaire en attendant des conditions meilleures.",
  faq_q3: 'Mon assurance couvre-t-elle la réparation ?',
  faq_a3: "Si la réparation est causée par un événement couvert (tempête, grêle, vent violent), votre assurance couvre généralement les dommages. On vous aide à préparer le dossier avec un rapport photo détaillé et une attestation de notre couvreur.",
  faq_q4: 'Pouvez-vous poser une bâche temporaire en attendant ?',
  faq_a4: "Oui, c'est souvent notre première étape en cas d'urgence. Une bâche d'étanchéité professionnelle protège votre toit jusqu'à la réparation définitive. C'est rapide, efficace, et inclus dans notre plan d'urgence.",
  faq_q5: 'Une réparation est-elle garantie ?',
  faq_a5: "Toutes nos réparations sont couvertes par une garantie écrite de 3 à 5 ans selon le type de travail. Si le même problème réapparaît à cause d'un défaut de notre part, on revient réparer sans frais.",

  // CTA Final
  cta_h2: "Toiture qui coule à Lévis ? On est là.",
  cta_subtitle: 'Intervention rapide, inspection gratuite, garantie écrite.',
  cta_button: 'Demander une inspection',
  cta_phone: '418-476-9950',

  // Formulaire
  form_h2: 'Demandez une inspection gratuite',
  form_subtitle: "Remplissez le formulaire — on vous rappelle en 1h pour les urgences.",
  form_success: 'Demande envoyée !',
  form_success_sub: "On vous rappelle rapidement. Merci de nous faire confiance.",
  form_name_label: 'Nom complet',
  form_name_placeholder: 'Votre nom',
  form_phone_label: 'Téléphone',
  form_phone_placeholder: '418-476-9950',
  form_email_label: 'Courriel',
  form_email_placeholder: 'votre@email.com',
  form_service_label: 'Type de problème',
  form_service_select: 'Sélectionnez un problème',
  form_message_label: 'Description du problème',
  form_message_placeholder: "Décrivez ce que vous observez : tache au plafond, bardeaux arrachés, glace au toit, etc.",
  form_char_count: '/500',
  form_urgent_label: 'Urgence active (eau qui coule actuellement)',

  // Header/Footer shared
  nav_home: 'Accueil',
  nav_services: 'Services',
  nav_about: 'À propos',
  nav_quote: 'Soumission',
  phone_number: '418-476-9950',
  cta_quote: 'Soumission gratuite',
  footer_brand: 'Couvreur-Lévis.com',
  footer_address: 'Lévis, QC, Canada',
  footer_email: 'contact@couvreur-levis.com',
  footer_services_title: 'Services',
  footer_link_refaction: 'Réfection toiture',
  footer_link_repair: 'Réparation',
  footer_link_flat: 'Toit plat',
  footer_link_metal: 'Tôle et métal',
  footer_link_inspection: 'Inspection',
  footer_links_title: 'Liens',
  footer_link_about: 'À propos',
  footer_link_quote: 'Soumission',
  footer_link_legal: 'Mentions légales',
  footer_link_privacy: 'Politique de confidentialité',
  footer_link_blog: 'Blog',
  footer_copyright: '© 2026 Couvreur-Lévis.com. Tous droits réservés.',
  footer_hours_title: 'Heures',
  footer_hours_week: 'Lun–Ven : 7h00 – 18h00',
  footer_hours_weekend: 'Sam–Dim : 8h00 – 16h00',
};

export default reparationTranslations;